export function enToRuLayout(text: string): string {
    const en = "qwertyuiop[]asdfghjkl;'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>~@#$^&";
    const ru = "йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё\"№;:?";
    let result = "";
    for (let char of text) {
      const idx = en.indexOf(char);
      result += idx !== -1 ? ru[idx] : char;
    }
    return result;
  }

export function ruToEnLayout(text: string): string {
    const en = "qwertyuiop[]asdfghjkl;'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>~@#$^&";
    const ru = "йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё\"№;:?";
    let result = "";
    for (let char of text) {
        const idx = ru.indexOf(char);
        result += idx !== -1 ? en[idx] : char;
    }
    return result;
}

/**
 * Функция для обработки кодов МКБ
 * Первая буква всегда должна быть английской, остальные - русскими
 * Пример: I20.0 -> I20.0, I20.0й -> I20.0й
 */
export function mkbCodeLayout(text: string): string {
    if (!text || text.length === 0) return text;
    
    const en = "qwertyuiop[]asdfghjkl;'zxcvbnm,./`QWERTYUIOP{}ASDFGHJKL:\"ZXCVBNM<>~@#$^&";
    const ru = "йцукенгшщзхъфывапролджэячсмитьбю.ёЙЦУКЕНГШЩЗХЪФЫВАПРОЛДЖЭЯЧСМИТЬБЮ,Ё\"№;:?";
    
    let result = "";
    
    for (let i = 0; i < text.length; i++) {
        const char = text[i];
        
        if (i === 0) {
            // Первая буква - всегда должна быть английской
            const idx = ru.indexOf(char);
            result += idx !== -1 ? en[idx] : char;
        } else {
            // Остальные символы - оставляем как есть (русские остаются русскими)
            result += char;
        }
    }
    
    return result;
}